import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const Wrapper = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const tokenString = localStorage.getItem('single_vendor_admin_token');

  let token = null;
  try {
    token = tokenString ? JSON.parse(tokenString) : null;
  } catch (error) {
    console.error("Invalid token in localStorage");
  }

  const isLoginPage = pathname.includes('login');

  if (!token && !isLoginPage) {
    return <Navigate to="/login" replace />;
  }

  if (token && isLoginPage) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default Wrapper;
